import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { addServer, updateServerData } from "@/api/gmtool/packageCode";
import { gmTool } from "@/mixins/index";
export default {
  mixins: [gmTool],
  props: {
    prod: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      dialogShow: false,
      paramsData: {
        serverId: '',
        serverName: '',
        is_timing: 2,
        time_to_run: '',
        config_state: '',
        new_tag: '',
        is_recomm: '',
        push_msg: ''
      },
      newTag: [{
        label: this.$t('yes'),
        value: true
      }, {
        label: this.$t('no'),
        value: false
      }],
      rules: {
        is_timing: [{
          required: true,
          message: this.$t('pleaseChoose'),
          trigger: "blur"
        }],
        serverName: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }],
        config_state: [{
          required: true,
          message: this.$t('pleaseChoose'),
          trigger: "blur"
        }],
        new_tag: [{
          required: true,
          message: this.$t('pleaseChoose'),
          trigger: "blur"
        }],
        is_recomm: [{
          required: true,
          message: this.$t('pleaseChoose'),
          trigger: "blur"
        }],
        time_to_run: [{
          required: true,
          message: this.$t('pleaseSelectTime'),
          trigger: "blur"
        }]
      },
      isMobile: false
    };
  },
  created: function created() {
    this.checkMobile();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize: function handleResize() {
      this.checkMobile();
    },
    open: function open(data) {
      this.dialogShow = true;
      this.paramsData = _objectSpread(_objectSpread({}, data), {}, {
        is_timing: 2
      });
    },
    addtag: function addtag(data) {
      this.paramsData.push_msg = "".concat(this.paramsData.push_msg).concat(data);
    },
    addDomain: function addDomain() {
      this.paramsData.data.push({
        server_id: "",
        server_name: ""
      });
    },
    hiad: function hiad() {
      this.dialogShow = false;
      this.clearData();
    },
    removeDomain: function removeDomain(item) {
      var index = this.ex_Val.indexOf(item);

      if (index !== -1) {
        this.paramsData.data.splice(index, 1);
      }
    },
    clearData: function clearData() {
      this.paramsData = {
        serverId: this.paramsData.serverId,
        serverName: '',
        is_timing: 2,
        time_to_run: '',
        config_state: '',
        new_tag: '',
        is_recomm: '',
        push_msg: ''
      };
      this.$refs.ruleForm.clearValidate();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          // let time_to_run = 0
          // if (this.paramsData.time_to_run) {
          //   let timestamp = (new Date()).valueOf();
          //   time_to_run = this.paramsData.time_to_run / 1000 - parseInt(timestamp / 1000)
          //   if (time_to_run <= 0) {
          //     this.$message.error('定时时间不能小于当前时间')
          //     return
          //   }
          // }
          var data = _objectSpread({
            serverID: _this.paramsData.serverID,
            serverName: _this.paramsData.serverName,
            is_timing: _this.paramsData.is_timing,
            time_to_run: _this.paramsData.time_to_run,
            showTime: _this.paramsData.time_to_run,
            config_state: JSON.stringify(_this.paramsData.config_state),
            new_tag: JSON.stringify(_this.paramsData.new_tag),
            is_recomm: JSON.stringify(_this.paramsData.is_recomm),
            push_msg: _this.paramsData.push_msg
          }, _this.prod);

          updateServerData(data).then(function (res) {
            if (res.status == 200) {
              _this.$message({
                message: _this.$t('modifySuccess'),
                type: 'success'
              });

              _this.dialogShow = false;

              _this.$emit('update');
            }
          });
        }
      });
    },
    textareaChange: function textareaChange() {
      var code = this.paramsData.textarea.split(/[(\r\n)\r\n]+/);
      var serList = [];
      code.forEach(function (item) {
        var d = item.split(",");
        serList.push({
          server_id: d[0],
          server_name: d[1]
        });
      });
    }
  }
};